<template>
  <v-container>
    <link
      rel="stylesheet"
      href="https://leaflet.github.io/Leaflet.markercluster/dist/MarkerCluster.css"
    />
    <link
      rel="stylesheet"
      href="https://leaflet.github.io/Leaflet.markercluster/dist/MarkerCluster.Default.css"
    />

    <!-- MAP -->
    <v-row align-content="center" justify="center">
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="10">
        <div id="container">
          <div id="mapContainer"></div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters /* mapActions  */ } from "vuex";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "leaflet-defaulticon-compatibility";
import * as L1 from "leaflet.markercluster";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import CustomPopup from "./CustomPopup.vue";
import Vue from "vue";
export default {
  name: "PollenFossileMap",
  props: ["dialog", "feature", "selected", "showonlyselected"],
  data: () => ({
    mapDiv: null,
    center: [6.6, 21],
  }),
  computed: {
    ...mapGetters("lipdpollenmoderne", ["getFiltered"]),
    geoJSONmarkers() {
      var thisData = this.showonlyselected ? this.selected : this.getFiltered;
      let geoJSONdata = thisData.map((x) => {
        /* let data = {
          ...x.geo,
          properties: {
            ...x.geo.properties,
            investigators: x.investigators,
            archiveType: x.archiveType,
            dataset_title: x.dataset_title,
            id_dataset: x.id_dataset,
            dataSetNameComplete: x.dataSetNameComplete,
            samplingDate: x.samplingDate,
          },
        }; */

        let data = {
          ...x.geo,
          geometry: {
            type: "Point",
            coordinates: x.geo.geometry.coordinates,
          },
          properties: {
            ...x.geo.properties,
            ...x,
          },
        };
        return data;
      });

      let geoJSONcollection = {
        type: "FeatureCollection",
        features: geoJSONdata,
      };

      const _this = this;

      var geoJsonLayer = L.geoJson(geoJSONcollection, {
        onEachFeature: function (feature, layer) {
          layer
            .bindPopup(() => {
              var ComponentClass = Vue.extend(CustomPopup);
              var isSelected = _this.selected.indexOf(feature.properties) > -1;
              var instance = new ComponentClass({
                propsData: { feature: feature, selected: isSelected },
              });
              instance.$mount();
              return instance.$el.innerHTML;
            })
            .on("popupopen", (a) => {
              var popUp = a.target.getPopup();

              popUp
                .getElement()
                .querySelector(".opendialog")
                .addEventListener("click", () => {
                  _this.openDialog(feature.properties);
                });

              popUp
                .getElement()
                .querySelector(".selectmap")
                .addEventListener("click", () => {
                  const index = _this.selectedd.indexOf(feature.properties);
                  if (index > -1) {
                    _this.selectedd.splice(index, 1);
                  } else {
                    _this.selectedd.push(feature.properties);
                  }
                  _this.mapDiv.closePopup();
                });
            });
        },
      });
      /* var geoJsonLayer = L.geoJson(geoJSONcollection); */
      var markers = new L1.MarkerClusterGroup({ showCoverageOnHover: true });
      markers.addLayer(geoJsonLayer);

      return markers;
    },
    sample_data() {
      return this.feature;
    },
    selectedd() {
      return this.selected;
    },
    accessTemplate() {
      let el = this.$refs.popup.$el;
      console.log(el);
      console.log(el.innerHTML);
      return el;
    },
  },

  methods: {
    /* ...mapActions(["fetchPaleodata"]), */
    openDialog(item) {
      this.$emit("update:feature", item);
      this.$emit("update:dialog", true);
    },
    closeDialog() {
      this.$emit("update:dialog", !this.dialog);
    },
    averageCoordinates(arrays) {
      let result = [];
      for (var i = 0; i < arrays[0].length; i++) {
        var num = 0;
        //still assuming all arrays have the same amount of numbers
        for (var i2 = 0; i2 < arrays.length; i2++) {
          num += arrays[i2][i];
        }
        result.push(Math.round(num / arrays.length));
      }
      return result;
    },
    setupLeafletMap() {
      const DefaultIcon = L.icon({
        iconUrl: icon,
        shadowUrl: iconShadow,
      });

      L.Marker.prototype.options.icon = DefaultIcon;
      this.mapDiv = L.map("mapContainer").setView(this.center, 1);
      L.tileLayer(
        "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
        {
          attribution:
            'Map data (c) <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery (c) <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 18,
          minZoom: 3,
          /* scrollWheelZoom: false, */
          id: "mapbox/satellite-v9",
          accessToken:
            "pk.eyJ1IjoiYWxlbW9yaSIsImEiOiJja2U0MmdkZHowcDFyMnhwZGc0dWgxNTIwIn0.AZJzeynr-RH04CF2OEuAoQ",
        }
      ).addTo(this.mapDiv);
      /* this.mapDiv.scrollWheelZoom.disable(); */
    },

    populateLeafletMap() {
      this.mapDiv.addLayer(this.geoJSONmarkers);
      /* this.mapDiv.fitBounds(this.geoJSONmarkers.getBounds()); */
    },

    async createMap() {
      /* await this.fetchPaleodata(); */
      await this.setupLeafletMap();
      this.populateLeafletMap();
    },
  },
  watch: {
    geoJSONmarkers(newMarkers, oldMarkers) {
      if (this.mapDiv) {
        this.mapDiv.removeLayer(oldMarkers);
        this.mapDiv.addLayer(newMarkers);
      }
    },
  },
  mounted() {
    this.createMap();
  },
  created() {
    this.createMap();
  },
};
</script>

<style scoped>
#mapContainer {
  width: 100%;
  z-index: 0;
  height: 500px;
}
</style>